export default __webpack_public_path__ + "static/media/logoPedidosYa.c6c39dfc.jpg";